module.exports = __webpack_public_path__ + "img/photo3_5.0c8a6cab.jpg";